import { MessageModel } from '../../models';

export abstract class MessageBase {
  public abstract showError(errorMessage: string): Promise<void>;

  public abstract showError(error: MessageModel): Promise<void>;

  public abstract showInfo(info: MessageModel): Promise<void>;

  public abstract showSuccess(success: MessageModel): Promise<void>;
}
